// {
// 	"logData": {
// 		"h": [
// 			{
// 				"c": {
// 					"id": 100678,
// 					"apr": 29,
// 					"notes": null,
// 					"bwr_zip": null,
// 					"created": "2025-03-17T11:02:21.055462",
// 					"has_pop": true,
// 					"hold_id": null,
// 					"is_held": false,
// 					"bwr_city": null,
// 					"has_ohno": false,
// 					"bwr_email": null,
// 					"bwr_state": null,
// 					"dealer_id": 6138,
// 					"hold_date": null,
// 					"hold_type": null,
// 					"is_active": true,
// 					"lender_id": 8,
// 					"loan_type": "Healthcare",
// 					"vision_id": 141499,
// 					"bwr_address": null,
// 					"has_bal_pay": false,
// 					"hold_status": null,
// 					"loan_number": "PP1368095",
// 					"loan_status": "active",
// 					"term_months": 4,
// 					"applicant_id": 109830,
// 					"has_buy_down": false,
// 					"has_stip_pay": false,
// 					"hold_comment": null,
// 					"hold_updated": null,
// 					"program_code": "POP-HC",
// 					"project_type": "AUDIOLOGY",
// 					"next_due_date": "2025-04-13",
// 					"application_id": null,
// 					"coapplicant_id": null,
// 					"portfolio_code": "POWERPAY-SO",
// 					"structure_tier": "PP12POP",
// 					"expiration_date": "2025-04-19",
// 					"hubspot_deal_id": "33677853793",
// 					"ohno_promo_term": 0,
// 					"hold_modified_by": null,
// 					"int_accrual_rate": 0,
// 					"loan_status_code": "",
// 					"payment_held_ids": [],
// 					"promo_cost_cents": 0,
// 					"last_payment_date": null,
// 					"program_fee_cents": 2344,
// 					"sponsor_affiliate": "Frasier Enterprises",
// 					"completed_payments": 1,
// 					"first_payment_date": null,
// 					"has_staged_funding": false,
// 					"merchant_app_count": "49/19/0",
// 					"buy_down_cost_cents": 0,
// 					"concierge_fee_cents": 0,
// 					"stip_pay_cost_cents": 0,
// 					"activation_fee_cents": 0,
// 					"total_past_due_cents": 0,
// 					"monthly_payment_cents": 1633,
// 					"number_payment_stages": 1,
// 					"partner_application_id": null,
// 					"funding_remaining_cents": 76056,
// 					"total_balance_due_cents": 78400,
// 					"total_loan_amount_cents": 78400,
// 					"current_amount_due_cents": 1633,
// 					"dealer_net_proceeds_cents": 76056,
// 					"final_stage_payment_cents": 0,
// 					"first_stage_payment_cents": 76056,
// 					"staged_funding_cost_cents": 0,
// 					"total_holdback_cost_cents": 0,
// 					"second_stage_payment_cents": 0,
// 					"pop_promo_program_fee_cents": 2344,
// 					"estimated_project_amount_cents": 78400,
// 					"current_principal_balance_cents": 78400
// 				},
// 				"v": 1,
// 				"ts": 1743796002818
// 			},
// 			{
// 				"c": {
// 					"activation_fee_cents": 10
// 				},
// 				"m": {
// 					"_r": "lucas.thomazoni@getpowerpay.com"
// 				},
// 				"v": 2,
// 				"ts": 1743797827839
// 			},
// 			{
// 				"c": {
// 					"first_stage_payment_cents": 75000
// 				},
// 				"m": {
// 					"_r": "test.user@getpowerpay.com"
// 				},
// 				"v": 3,
// 				"ts": 1743798558629
// 			},
// 			{
// 				"c": {
// 					"next_due_date": "2025-04-04"
// 				},
// 				"m": {
// 					"_r": "test.user@getpowerpay.com"
// 				},
// 				"v": 4,
// 				"ts": 1743798829346
// 			},
// 			{
// 				"c": {
// 					"expiration_date": "2026-04-04"
// 				},
// 				"m": {
// 					"_r": "test.user@getpowerpay.com"
// 				},
// 				"v": 5,
// 				"ts": 1743798946617
// 			},
// 			{
// 				"c": {
// 					"expiration_date": "2027-04-04"
// 				},
// 				"m": {
// 					"_r": "test.user@getpowerpay.com"
// 				},
// 				"v": 6,
// 				"ts": 1743799343567
// 			},
// 			{
// 				"c": {
// 					"hold_id": 180065,
// 					"is_held": true,
// 					"hold_date": "2025-04-04",
// 					"hold_type": "payment",
// 					"hold_status": "Hold for payment",
// 					"hold_updated": "2025-04-04 20:43:57.692724",
// 					"hold_modified_by": "test.user@getpowerpay.com",
// 					"payment_held_ids": "{180065}"
// 				},
// 				"v": 7,
// 				"ts": 1743799437693
// 			},
// 			{
// 				"c": {
// 					"completed_payments": 0
// 				},
// 				"v": 8,
// 				"ts": 1743799437696
// 			}
// 		],
// 		"v": 8
// 	}
// }


import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { centsToDollar } from '../utils/formatters';

/**
 * Component to display differences between history entries
 * @param {Object} props - Component props
 * @param {Object} props.logData - Log data object containing history entries
 */
const HistoryDiff = ({ logData }) => {
  const [showInitialData, setShowInitialData] = useState(false);

  if (!logData || !logData.h || logData.h.length < 1) {
    return <div className="history-diff-empty">No history changes to display</div>;
  }

  // Extract the history entries
  const historyEntries = logData.h;

  // Find v1 data
  const v1Entry = historyEntries.find(entry => entry.v === 1) || historyEntries[0];

  // Sort entries by version (newest first) - excluding v1 for diffs
  const sortedEntries = [...historyEntries].sort((a, b) => b.v - a.v);

  // Create a consolidated lookup of all previous values by version
  const versionLookup = {};

  // Start with v1 and build up
  const entriesByVersion = [...historyEntries].sort((a, b) => a.v - b.v);

  // Build consolidated state at each version
  let consolidatedState = {};
  entriesByVersion.forEach(entry => {
    consolidatedState = { ...consolidatedState, ...entry.c };
    versionLookup[entry.v] = { ...consolidatedState };
  });

  // Generate diff pairs with proper historical values
  const diffPairs = [];
  for (let i = 0; i < sortedEntries.length - 1; i++) {
    const current = sortedEntries[i];
    const previous = sortedEntries[i + 1];

    // Find all changes in current version
    const diff = {};

    if (current.c) {
      Object.keys(current.c).forEach(key => {
        const newValue = current.c[key];

        // Find the most recent previous value by looking back through versions
        let oldValue = undefined;
        let foundOldValue = false;

        // Check immediate previous version first
        if (previous.c && previous.c.hasOwnProperty(key)) {
          oldValue = previous.c[key];
          foundOldValue = true;
        }

        // If not found, look back through all previous versions
        if (!foundOldValue) {
          for (let v = current.v - 1; v >= 1; v--) {
            if (versionLookup[v] && versionLookup[v].hasOwnProperty(key)) {
              oldValue = versionLookup[v][key];
              foundOldValue = true;
              break;
            }
          }
        }

        // Only add to diff if the value actually changed
        if (newValue !== oldValue) {
          diff[key] = {
            oldValue: oldValue,
            newValue: newValue
          };
        }
      });
    }

    diffPairs.push({
      current,
      previous,
      diff
    });
  }

  const toggleInitialData = () => {
    setShowInitialData(!showInitialData);
  };

  // Format the creation date for display in the header
  const formattedCreationDate = v1Entry ? new Date(v1Entry.ts).toLocaleString() : 'Unknown';

  return (
    <div className="history-diff-container">
      {/* Diffs for changes */}
      {diffPairs.length === 0 ? (
        <div className="history-diff-empty">No changes to display</div>
      ) : (
        diffPairs.map((pair, index) => (
          <DiffItem
            key={index}
            current={pair.current}
            previous={pair.previous}
            diff={pair.diff}
          />
        ))
      )}

      {/* Initial dataset (v1) with collapsible feature */}
      <div className="history-diff-initial">
        <div
          className="history-diff-initial-header"
          onClick={toggleInitialData}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === 'Enter' && toggleInitialData()}
        >
          <div className="history-diff-initial-title">
            <h4>Initial Data (Version 1)</h4>
            <span className="history-diff-initial-date">
              Created: {formattedCreationDate}
            </span>
          </div>
          <span className="history-diff-toggle">
            {showInitialData ? '▼' : '►'}
          </span>
        </div>

        {showInitialData && (
          <div className="history-diff-item">
            <div className="history-diff-header">
              <span className="history-diff-date">
                {new Date(v1Entry.ts).toLocaleString()}
              </span>
              <span className="history-diff-version">
                Initial Version
              </span>
            </div>

            <div className="history-diff-initial-data">
              <table className="history-diff-table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {v1Entry.c && Object.keys(v1Entry.c).map(key => (
                    <tr key={key}>
                      <td>{formatKey(key)}</td>
                      <td>{formatValue(key, v1Entry.c[key])}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Display a single diff item
 */
const DiffItem = ({ current, previous, diff }) => {
  const date = new Date(current.ts);
  const modifier = current.m && current.m._r ? current.m._r : 'system (?)';

  return (
    <div className="history-diff-item">
      <div className="history-diff-header">
        <span className="history-diff-date">
          <strong>{date.toLocaleString()}</strong>
        </span>
        <span className="history-diff-user">
          Modified by: {modifier}
        </span>
        <span className="history-diff-version">
          Version: {current.v}
        </span>
      </div>

      <div className="history-diff-changes">
        {Object.keys(diff).length === 0 ? (
          <p>No changes detected</p>
        ) : (
          <table className="history-diff-table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Previous Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(diff).map(key => (
                <tr key={key}>
                  <td>{formatKey(key)}</td>
                  <td className="history-diff-old-value">
                    {formatValue(key, diff[key].oldValue)}
                  </td>
                  <td className="history-diff-new">
                    {formatValue(key, diff[key].newValue)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

// Format functions moved outside component to be reused
const formatKey = (key) => {
  return key
    .replace(/_cents/g, '')
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const formatValue = (key, value) => {
  if (value === null || value === undefined) {
    return '-';
  }

  // Handle boolean values
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  if (key.includes('_cents')) {
    return centsToDollar(value);
  }

  return value;
};

HistoryDiff.propTypes = {
  logData: PropTypes.shape({
    h: PropTypes.arrayOf(PropTypes.shape({
      c: PropTypes.object, // content
      m: PropTypes.object, // metadata
      v: PropTypes.number, // version
      ts: PropTypes.number  // timestamp
    })),
    v: PropTypes.number
  })
};

export default HistoryDiff;
